import { render, staticRenderFns } from "./DashboardCustomizado.vue?vue&type=template&id=20a04d47"
import script from "./DashboardCustomizado.vue?vue&type=script&lang=js"
export * from "./DashboardCustomizado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports